export const config = {
    Dates: [
        {
            Date: "October 2020",
            Text: "The Board of Admissions and Relations with Schools initially approves a work group for the ethnic studies requirement."
        },
        {
            Date: "November 2021",
            Text: "BOARS approves an initial draft for the Academic Council to place under systemwide review, with some concerns."
        },
        {
            Date: "March 2022",
            Text: "Systemwide review generates largely supportive feedback from every campus, with notable concerns, and the Academic Council decides to send the proposal back to BOARS."
        },
        {
            Date: "April 2022",
            Text: "Ethnic Studies work group addresses critiques and provides revisions."
        },
        {
            Date: "May 6, 2022",
            Text: "In a May meeting, BOARS remains unswayed."
        },
        {
            Date: "May 12, 2022",
            Text: "Christine Hong and Andrew Jolivette issue a statement defending the requirement as written."
        },
        {
            Date: "May 31, 2022",
            Text: "A letter to BOARS from some University of California faculty sharply criticizes the requirement."
        },
        {
            Date: "June 3, 2022",
            Text: "In the BOARS’ June meeting, several local admissions committees are split on whether to continue or end deliberations on the requirement."
        },
        {
            Date: "July 2022",
            Text: "In the BOARS’ July meeting, a possible working group tackling concerns about the implementation of the requirement is suggested."
        }
    ]
};